(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("YtE9h", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b5c99e6a0876eaa$export$71511d61b312f219; });
function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


var $YtE9h = parcelRequire("YtE9h");
var $4e80cf122b9d3f49$var$faq = {
    settings: {
        faqItems: document.querySelectorAll('.js-faq')
    },
    init: function() {
        this.setEvents();
    },
    setEvents: function() {
        var _this = this;
        this.settings.faqItems.forEach(function(item) {
            var button = item.querySelector('.js-btn');
            var toggle = document.getElementById(button.getAttribute('aria-controls'));
            button.addEventListener('click', function() {
                return _this.toggle(button, toggle);
            });
            button.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    _this.toggle(button, toggle);
                }
            });
        });
    },
    toggle: function(activeButton) {
        var _this = this;
        var isExpanding = activeButton.getAttribute('aria-expanded') !== 'true';
        this.settings.faqItems.forEach(function(item) {
            var button = item.querySelector('.js-btn');
            var content = document.getElementById(button.getAttribute('aria-controls'));
            var isCurrent = button === activeButton;
            var shouldExpand = isCurrent && isExpanding;
            button.setAttribute('aria-expanded', shouldExpand);
            button.setAttribute('aria-disabled', shouldExpand);
            content.setAttribute('aria-hidden', !shouldExpand);
            if (shouldExpand) _this.expand(content);
            else _this.collapse(content);
        });
    },
    expand: function(el) {
        el.hidden = false;
        if ((typeof gsap === "undefined" ? "undefined" : (0, $YtE9h._)(gsap)) === 'object' && gsap !== null) gsap.fromTo(el, {
            height: 0
        }, {
            height: el.scrollHeight,
            duration: 0.4,
            onComplete: function() {
                return el.style.height = '';
            }
        });
        else {
            el.style.maxHeight = '0px';
            el.offsetHeight;
            el.style.maxHeight = el.scrollHeight + 'px';
            el.addEventListener('transitionend', function() {
                el.style.maxHeight = '';
            }, {
                once: true
            });
        }
    },
    collapse: function(el) {
        if ((typeof gsap === "undefined" ? "undefined" : (0, $YtE9h._)(gsap)) === 'object' && gsap !== null) gsap.to(el, {
            height: 0,
            duration: 0.2,
            onComplete: function() {
                el.hidden = true;
                el.style.height = '';
            }
        });
        else {
            el.style.maxHeight = el.scrollHeight + 'px';
            el.offsetHeight;
            el.style.maxHeight = '0px';
            el.addEventListener('transitionend', function() {
                el.hidden = true;
            }, {
                once: true
            });
        }
    }
};
window.addEventListener('DOMContentLoaded', function() {
    return $4e80cf122b9d3f49$var$faq.init();
});

})();
//# sourceMappingURL=script.js.map
